import { useId } from "@mantine/hooks"
import produce from "immer"
import React from "react"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import classNames from "utils/classNames"

type ReOrderListType = {
  list: any[]
  renderItem?: (item: any, index: number) => any
  id?: string
  onSequenceChange?: (list: any[]) => void
  draggableClassName?: string
  staleClassName?: string
  disabled?: boolean
}
const ReOrderList = ({
  list,
  renderItem,
  id,
  draggableClassName,
  staleClassName,
  disabled,
  onSequenceChange,
}: ReOrderListType) => {
  const uuid = useId()

  return (
    <DragDropContext
      onDragEnd={({ source, destination }) => {
        const prevIndex = source.index
        const newIndex = destination.index
        if (!source || !destination) return
        if (
          destination.droppableId === source.droppableId &&
          prevIndex === newIndex
        ) {
          return
        }
        onSequenceChange(
          produce(list, draft => {
            const item = draft[prevIndex]
            draft.splice(prevIndex, 1)
            draft.splice(newIndex, 0, item)
          })
        )
        // Logic goes here
      }}
    >
      <Droppable isDropDisabled={disabled} droppableId={id || uuid}>
        {({ droppableProps, placeholder, innerRef }) => {
          return (
            <section ref={innerRef} {...droppableProps}>
              {list.map((c, index) => {
                const key = c.id?.toString()

                return (
                  <Draggable
                    isDragDisabled={disabled}
                    index={index}
                    draggableId={key}
                    key={key}
                  >
                    {(
                      { draggableProps, dragHandleProps, innerRef },
                      { isDragging }
                    ) => {
                      return (
                        <div
                          ref={innerRef}
                          {...draggableProps}
                          {...dragHandleProps}
                          className={classNames(
                            draggableClassName,
                            !isDragging && staleClassName,
                            isDragging && "bg-blue-100"
                          )}
                        >
                          {renderItem(c, index)}
                        </div>
                      )
                    }}
                  </Draggable>
                )
              })}
              {placeholder}
            </section>
          )
        }}
      </Droppable>
    </DragDropContext>
  )
}

export default ReOrderList
